import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lib-static-dynamic-table-oqms',
  templateUrl: './static-dynamic-table-oqms.component.html',
  styleUrls: ['./static-dynamic-table-oqms.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticDynamicTableOqmsComponent implements AfterViewInit {
  @ViewChildren('tableWrap') tableWraps!: QueryList<ElementRef<HTMLElement>>;
  @Input() columns: any[] = [];
  @Input() rows: any[] = [];
  @Input() tableHeight: any = '50em';
  @Output() railGroupClick = new EventEmitter<any>();

  onRowClick(name, groupName) {
    this.railGroupClick.emit({ name, groupName });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.tableWraps.forEach((wrapEl) => {
        const wrap = wrapEl.nativeElement;
        const table = wrap.querySelector('table');
        const headerRow = table?.querySelector('thead tr');
        if (!headerRow) return;

        const th1 = headerRow.children[0] as HTMLElement;
        const th2 = headerRow.children[1] as HTMLElement;

        const w1 = Math.ceil(th1.getBoundingClientRect().width);
        const w2 = Math.ceil(th2.getBoundingClientRect().width);

        wrap.style.setProperty('--c1', `${w1}px`);
        wrap.style.setProperty('--c2', `${w2}px`);
      });
    });
  }
}
